import { useQuery } from '@tanstack/react-query';
import { getPageReadiness, getSinglePageReadiness } from '../services/modeService';
import { PageReadinessResponse } from '../types/mode.types';

export const usePageReadiness = (
  siteId: number,
  page: number = 0,
  size: number = 50,
  sortBy: string = 'id',
  sortDir: string = 'ASC'
) => {
  return useQuery<PageReadinessResponse[]>({
    queryKey: ['pageReadiness', siteId, page, size, sortBy, sortDir],
    queryFn: () => getPageReadiness(siteId, page, size, sortBy, sortDir),
    enabled: !!siteId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useSinglePageReadiness = (siteId: number, pageId: number) => {
  return useQuery<PageReadinessResponse>({
    queryKey: ['pageReadiness', siteId, pageId],
    queryFn: () => getSinglePageReadiness(siteId, pageId),
    enabled: !!siteId && !!pageId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
